import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {};
const qs = {
  popup: 'data-country-pop',
  content: 'data-country-pop-content',
  selector: 'data-country-select',
  selected: 'data-country-pop-selected',
  welcome: 'data-country-pop-welcome',
  welcomeText: 'data-country-pop-welcome-text',
  countryData: 'data-country-data',
  selectedCountryHead: 'data-selected-country',
}
const qsAll = {
  items: 'data-country-pop-item',
  closes: 'data-country-pop-close',
}

const toggleModal = (toggle = true) => {
  if(toggle) {
    dom.content.classList.remove('hidden')
    dom.welcome.classList.add('hidden')
  }
  console.log('toggle', toggle)
  dom.popup.classList.toggle('!flex', toggle)
  dom.popup.classList.toggle('z-[-1]', !toggle)
  dom.popup.classList.toggle('opacity-0', !toggle)
  dom.popup.classList.toggle('z-30', toggle)
  dom.popup.classList.toggle('opacity-100', toggle)
  document.body.classList.toggle('overflow-hidden', toggle)
}

const setInitCountry = (countryData) => {
  dom.selected.innerHTML = countryData.country_now
  dom.selector.innerHTML = `<img class="h-3" src="${countryData.flag_image}" alt="${countryData.country}" />
    <span class="font-tinos text-sm  leading-4 capitalize">${countryData.country}</span>
    <span class="text-sm  leading-4 capitalize">+</span>`
}

export const setupCountrySelector = () => {
  cacheDom(dom, qs, qsAll)
  if(dom.selector) {
    dom.selector.addEventListener('click', (e) => {
      toggleModal()
    })
    dom.closes.forEach((close) => {
      close.addEventListener('click', () => {
        toggleModal(false)
      })
    })
    dom.items.forEach((item) => {
      item.addEventListener('click', (e) => {
        Cookies.set('cookie_country', e.target.tagName == 'BUTTON' ? e.target.dataset.countryPopItem : e.target.closest('button').dataset.countryPopItem)
        const countryData = JSON.parse(dom.countryData.innerHTML).filter((country) => country.country == Cookies.get('cookie_country'))[0]

        setInitCountry(countryData)
        dom.selectedCountryHead.innerHTML = `<img class="w-6 h-3 mr-3" src="${countryData.flag_image}" alt="${countryData.country}" />
        ${countryData.country}`
        dom.welcomeText.innerHTML = countryData.welcome
        dom.content.classList.add('hidden')
        dom.welcome.classList.remove('hidden')
      })
    })
    if(typeof Cookies.get('cookie_country') != 'undefined') {
      const countryData = JSON.parse(dom.countryData.innerHTML).filter((country) => country.country == Cookies.get('cookie_country'))[0]
      setInitCountry(countryData)
    }
  }
}